export enum EStatusType {
    success = 'success',
    process = 'process',
    pending = 'pending',
    attention = 'attention',
    error = 'error',
    default = 'default'
}
